import { useState } from 'react';
import { Share, SquarePlus, X } from 'lucide-react';
import { Card } from '@tcrd/ui';
import { env } from '../lib/env';

/** iPhone/iPad: las notificaciones web solo funcionan con la app instalada en la pantalla de inicio (iOS 16.4+). */
export const isIos = () => /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const isInstalledPwa = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;
export const needsIosInstall = () => !env.isNative && isIos() && !isInstalledPwa();

const KEY = 'tcrd:ios-install-hint';

/** Pasos para instalar la web en el iPhone. `dismissible`: aviso en el inicio que se puede cerrar. */
export function IosInstallHint({ dismissible = false }: { dismissible?: boolean }) {
  const [hidden, setHidden] = useState(() => {
    try {
      return dismissible && localStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  });
  if (!needsIosInstall() || hidden) return null;
  const close = () => {
    try {
      localStorage.setItem(KEY, '1');
    } catch {
      /* sin almacenamiento */
    }
    setHidden(true);
  };
  return (
    <Card className="p-4 border border-sky-200 bg-sky-50 dark:bg-sky-500/10 relative">
      {dismissible && (
        <button className="tap absolute right-2 top-2 size-8 flex items-center justify-center text-[var(--text-muted)]" onClick={close} aria-label="Cerrar">
          <X className="size-4" />
        </button>
      )}
      <p className="text-sm font-semibold pr-6">Recibe avisos de tu viaje en el iPhone</p>
      <p className="text-xs text-[var(--text-muted)] mt-1">En iPhone, los avisos solo funcionan con TuConductorRD instalada en tu pantalla de inicio:</p>
      <ol className="mt-2 text-sm flex flex-col gap-1.5">
        <li className="flex items-center gap-2">1. Toca <Share className="size-4 inline" aria-label="Compartir" /> <strong>Compartir</strong> (abajo en Safari, arriba en Chrome)</li>
        <li className="flex items-center gap-2">2. Elige <SquarePlus className="size-4 inline" aria-hidden /> <strong>Agregar a pantalla de inicio</strong></li>
        <li>3. Abre TuConductorRD <strong>desde el ícono</strong> e inicia sesión</li>
        <li>4. En <strong>Perfil → Notificaciones</strong> toca <strong>Activar</strong></li>
      </ol>
    </Card>
  );
}
